import axios from "../../utils/axios";

//
export function messageList(params) {
    return axios({
        url: "/admin/message/list",
        method: "get",
        params: params
    });
}

//
export function messageSave(data, formName, method = "post") {
    let url =
        formName === "add"
            ? "/admin/message/add"
            : "/admin/message/update";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

//
export function messageDelete(data) {
    return axios({
        url: "/admin/message/delete",
        method: "post",
        data: data
    });
}
